/**
 * The five membership roles.
 *
 * These have existed as a `CHECK` constraint on `memberships.role` and `invites.role`
 * since migration `0001` and as **nothing else** — no constant, no set-equality test.
 * That was survivable while no code read them. c27 makes them code: the `authorize`
 * matrix in `apps/api` is keyed on this list, which would have made it a *third* copy of
 * a vocabulary already written twice.
 *
 * So this file arrives with the same three things every other enumerated column in this
 * schema carries (ruled 2026-08-04): `text` + `CHECK` in SQL, a constant here, and
 * `packages/db/test/constraints.test.ts` asserting the two are set-equal by reading
 * `information_schema`. Without the third, the choice merely relocates the drift from
 * "enum vs code" to "CHECK vs code", which is worse because it looks safer.
 *
 * **Order is not significance.** Unlike `TIERS`, this is not a ladder: `billing` is not
 * "above" `analyst`, and no code may compare roles by index. Capability is decided by
 * the matrix in `permissions.ts`, resource by resource, because that is
 * the only place the real answer is knowable — an editor may publish a recall and may
 * not retire a product, which no ordering can express.
 */
export const ROLES = ["owner", "admin", "editor", "analyst", "billing"];
/** Narrow an untrusted string — a session claim, a request body — to a known role. */
export function isRole(value) {
    return ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map